(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/receipt/receipt.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/receipt/receipt.js');
"use strict";

const {
  Fragment
} = React;
const Button = svs.ui.ReactButton;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  HEADER,
  DIGITAL_RECEIPT,
  PHYSICAL_RECEIPT,
  BUTTON_LABEL
} = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS;
const {
  MY_ORDERS_TEXT,
  MY_ORDERS_LINK_TEXT,
  PASSWORD_SENT
} = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS.DIGITAL;
const {
  INFO
} = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS.PHYSICAL;
const {
  MY_ORDERS,
  DIGITAL_TICKETS,
  PHYSICAL_TICKETS
} = svs.ticket_partner.constants.routes;
const {
  Link
} = svs.app.ReactRouter;
const Receipt = _ref => {
  let {
    type,
    email = null,
    isLoggedIn = false
  } = _ref;
  const isDigital = type === DIGITAL_RECEIPT;
  const isPhysical = type === PHYSICAL_RECEIPT;
  const buttonLink = "/foretagslotter".concat(isDigital ? DIGITAL_TICKETS : PHYSICAL_TICKETS);
  const MyOrdersLink = () => React.createElement(Fragment, null, MY_ORDERS_TEXT, React.createElement(Link, {
    to: MY_ORDERS
  }, MY_ORDERS_LINK_TEXT));
  return React.createElement(Fragment, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h1", null, HEADER), isDigital && React.createElement(Fragment, null, React.createElement("div", null, email && React.createElement("p", null, "En bekr\xE4ftelse p\xE5 best\xE4llningen skickas inom kort till angiven E-postadress (".concat(email, ")"))), React.createElement("div", null, isLoggedIn ? React.createElement(MyOrdersLink, null) : PASSWORD_SENT)), isPhysical && React.createElement("p", null, INFO))), isLoggedIn && React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    md: 6,
    sm: 12
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(Button, {
    href: buttonLink,
    transparent: true
  }, BUTTON_LABEL)))));
};
svs.ticket_partner.sharedComponents.receipt.Receipt = Receipt;

 })(window);